module.exports = __webpack_public_path__ + "3e2c5b4b4df72b7cc38e8dc8f0313a80.svg";